const defaultState = {
  signupCity: 'Abia',
  signupCities: {},
  productActionSelectionList: false,
  productActionSelection: '',
  fileContent: undefined,
  fileContentTwo: undefined,
  adminProductUploadState: false,
  productUploadResponse: '',
};

export default (state = defaultState, action) => {
  switch(action.type){
      case 'SET_SIGNUP_CITY':
        return {
          ...state,
          signupCity: action.signupCity
        }
      case 'SET_SIGNUP_CITIES':
        return {
          ...state,
          signupCities: action.signupCities
        }
      case 'SET_PRODUCT_ACTION_SELECTION_LIST':
        return {
          ...state,
          productActionSelectionList: action.productActionSelectionList
        }
      case 'SET_PRODUCT_ACTION_SELECTION':
        return {
          ...state,
          productActionSelection: action.productActionSelection
        }
      case 'SET_FILE_CONTENT':
        return {
          ...state,
          fileContent: action.fileContent,
        }
    case 'SET_FILE_CONTENT_TWO':
      return {
        ...state,
        fileContentTwo: action.fileContentTwo,
      }
    case 'SET_ADMIN_PRODUCT_UPLOAD_STATE':
      return {
        ...state,
        adminProductUploadState: action.adminProductUploadState,
      }
    case 'SET_ADMIN_PRODUCT_UPLOAD_RESPONSE':
      return {
        ...state,
        adminProductUploadResponse: action.adminProductUploadResponse,
      }
    default:
      return state;
  };
};
